import { Box, Grid } from "@mui/material";
import CognitoVerifyForgotPasswordForm from "./cognito/CognitoVerifyForgotPasswordForm";
import { AuthHeader, AuthSubHeader } from "./components/Headers";

export default function VerifyForgotPassword({
  formState,
  updateFormState,
  updateFormType,
  setProcessing,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AuthHeader text="Verify" />
      <AuthSubHeader text="Please check your email for your verification code" />

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <CognitoVerifyForgotPasswordForm
            formState={formState}
            updateFormState={updateFormState}
            updateFormType={updateFormType}
            setProcessing={setProcessing}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
